// Function to add our give data into cache
export function addDataIntoCache (cacheName: string, url: string, response: any) {
    // Converting our respons into Actual Response form
    const data = new Response(JSON.stringify(response));

    if ('caches' in window) {
        // Opening given cache and putting our data into it
        caches.open(cacheName).then((cache) => {
            cache.put(url, data);
        });
    }
};

// Function to get single cache data
export async function getSingleCacheData(cacheName: string, url: string,
    setCacheData: React.Dispatch<React.SetStateAction<any>>) {
    if (typeof caches === 'undefined') return [];

    const cacheStorage = await caches.open(cacheName);
    const cachedResponse = await cacheStorage.match(url);

    // If no cache exists
    if (!cachedResponse || !cachedResponse.ok) {
        setCacheData([]);
    }
    else {
        cachedResponse.json().then((item) => {
            setCacheData(item)
        })
    }
};

export async function deleteCache(cacheName: string) {
    if (typeof caches === 'undefined') return;
    caches.delete(cacheName);
}